import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import Modal from 'react-modal';
import { firebaseConfig } from '../../firebase';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const Log_in = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [registrationNumber, setRegistrationNumber] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setRegistrationNumber('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;
      // Fetch registration number from Firestore
      const userDoc = await getDoc(doc(db, 'registrations', uid));
      let regNum = '';
      if (userDoc.exists() && userDoc.data().registrationNumber) {
        regNum = userDoc.data().registrationNumber;
      }
      setRegistrationNumber(regNum);
      setModalOpen(true);
    } catch (e) {
      setError('Invalid email or password.');
    }
  };

  const inputClass =
    "w-full text-[10px] md:text-3xl bg-[#03897B] focus:bg-[#03897B] text-white placeholder:text-white placeholder:font-bold rounded-lg placeholder:pl-5 mb-4 p-2 h-[48px] md:h-[58px] border-2 md:px-6 border-[#FDBD26]";

  return (
    <div className="px-4 md:px-24 py-6">
      <div className="z-0 w-full relative flex flex-col items-start justify-center text-left font-inter">
        {/* Header */}
        <div className="flex w-full justify-between items-start mt-6 md:mt-10">
          <div>
            <h2 className="text-[22px] md:text-[36px] text-[#03897B] lg:text-[47px] font-bold leading-[120%]">
              LOG IN
            </h2>
            <h2 className="text-[16px] sm:text-[20px] md:text-[32px] font-semibold text-[#979797] leading-[120%] italic mt-1">
              Log in to farmnet
            </h2>
          </div>
        </div>
        {/* Sub Header */}
        <div className="flex w-full justify-between items-start mt-5">
          <div>
            <h2 className="text-[16px] sm:text-[20px] md:text-[28px] font-bold leading-[120%] mt-6">
              Farm IT, Digitalize IT!
            </h2>
          </div>
          <img
            className="hidden md:block w-[180px] h-[50px] object-cover"
            alt="Logo"
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746207768/image_65_d0whes.png"
          />
        </div>
        {/* Form */}
        <form className="w-full mt-6 md:mt-8" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={inputClass}
            placeholder="Enter Email Address"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={inputClass}
            placeholder="Enter Password"
          />
          <button
            type="submit"
            className="w-full h-[48px] md:h-[58px] mt-4 md:mt-5 bg-[#F38323] text-white rounded-lg text-[10px] md:text-[20px] flex shadow-inner shadow-black/30 text-center items-center justify-center"
          >
            <b>Continue</b>
          </button>
          {error && <div className="text-red-600 mt-2">{error}</div>}
        </form>
        {/* Reset Password Section */}
        <Link to="/Recover">
          <div className="mt-6 md:mt-8 space-y-1 md:space-y-0 md:mb-10 cursor-pointer">
            <h2 className="text-[16px] md:text-[20px] font-normal">Reset password</h2>
            <h2 className="text-[16px] md:text-[20px] font-normal">Recover your</h2>
            <h2 className="text-[16px] md:text-[20px] font-normal">password</h2>
            <h2 className="text-[16px] md:text-[20px] font-normal">By</h2>
            <h2 className="text-[20px] md:text-[20px] font-bold">Farmers Networks</h2>
          </div>
        </Link>
      </div>
      {/* Success Modal */}
      <Modal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} contentLabel="Login Success"      className="modal-content1"
            overlayClassName="modal-overlay">
        <button
          onClick={() => setModalOpen(false)}
          className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
          aria-label="Close"
        >
          &times;
        </button>
        <div className="relative bg-white p-4 rounded-lg w-[300px] md:w-[500px] mx-auto">
          <div className="flex flex-col items-center justify-center text-center h-full w-full">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
              alt="Success"
              className="mb-4 w-[40px] h-[40px] md:w-[60px] md:h-[60px]"
            />
            <div className="text-[16px] md:text-[36px] font-bold text-center w-full">
              Login Successful
            </div>
            <p className="text-black text-[10px] md:text-[24px] mb-2 mt-3">
              Welcome back to Ad-Luck!
            </p>
            {registrationNumber && (
              <>
                <p className="text-black text-[10px] md:text-[18px] mb-3">
                  Your unique registration number is:
                </p>
                <span className="text-[14px] md:text-[28px] font-bold text-center tracking-wide">{registrationNumber}</span>
              </>
            )}
            <button
              onClick={() => {
                setModalOpen(false);
                navigate('/');
              }}
              className="bg-[#03897B] mt-6 hover:bg-[#1b4a46] text-[12px] md:text-[20px] text-white w-full md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
            >
              Continue to Home
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Log_in;